import { z } from 'zod'
import { UserPermissionsGroupDTO, mapDTOToUserPermissionsGroup } from '../../../permission-groups/gateways/DTOs/UserPermissionsGroupDTO'
import { UserSettingsDTO, mapUserSettingsToDTO, mapDTOToUserSettings } from './UserSettingsDTO'
import { BaseCompanyDTO, mapDTOToBaseCompany, mapBaseCompanyToDTO } from '~/domain/shared/company/gateways/DTOs/BaseCompanyDTO'
import {
  TwoFactorStatusDTO,
  mapDTOToTwoFactorStatus
} from '~/domain/shared/two-factor/gateways/DTOs/TwoFactorStatusDTO'
import type { DashboardUser } from '~/domain/dashboard/user/users/models/DashboardUser'

export const UserDTO = z.object({
  id: z.number().optional(),
  name: z.string().nullish(),
  email: z.string().nullish(),
  password: z.string().nullish(),
  profile_id: z.number().nullish(),
  profile: UserPermissionsGroupDTO.nullish(),
  companies: BaseCompanyDTO.array().nullish(),
  settings: UserSettingsDTO.nullish(),
  two_factor_status: TwoFactorStatusDTO.nullish()
})

export type UserDTO = z.infer<typeof UserDTO>

export function mapUserToDTO (user: DashboardUser): UserDTO {
  const email = user.emails.filter(e => e.length > 0)?.[0]

  return {
    id: user.id,
    name: user.name,
    email,
    password: (user.password?.length ?? 0) > 0 ? user.password : undefined,
    profile_id: user.permissionGroup?.id,
    companies: user.companies.map(mapBaseCompanyToDTO),
    settings: user.settings ? mapUserSettingsToDTO(user.settings) : undefined
  } as UserDTO
}

export function mapDTOToUser (dto: UserDTO): DashboardUser {
  return {
    id: dto.id,
    name: dto.name ?? '',
    emails: dto.email != null ? [dto.email] : [],
    permissionGroup: dto.profile ? mapDTOToUserPermissionsGroup(dto.profile) : undefined,
    companies: dto.companies?.map(mapDTOToBaseCompany) ?? [],
    addresses: [],
    documents: [],
    phones: [],
    settings: dto.settings ? mapDTOToUserSettings(dto.settings) : undefined,
    twoFactorStatus: dto.two_factor_status ? mapDTOToTwoFactorStatus(dto.two_factor_status) : undefined
  }
}
